import { MappableModel } from './mappable-model'

export class Variation extends MappableModel {
  public id: number
  public uuid: string
  public name: string
  public description: number
  public sku: string
  public weight: number
  public position: number
  public price: number
  public wholesale_price: number
  public full_name: string
  public item_id: number
  public store_id: number
  public start_date: Date
  public end_date: Date
  public visible: boolean
  public is_donation: boolean
  public strict: string
  public disabled: Date
  public background_check_required: boolean
  public price_cents: number
  public currency: string
  public payment_plan_eligible: boolean
  public discount_code_eligible: boolean
  public use_flat_fee: boolean
}
